import { render, staticRenderFns } from "./UserP2PRequisites.vue?vue&type=template&id=01fec01d&scoped=true&"
import script from "./UserP2PRequisites.vue?vue&type=script&lang=js&"
export * from "./UserP2PRequisites.vue?vue&type=script&lang=js&"
import style0 from "./UserP2PRequisites.vue?vue&type=style&index=0&id=01fec01d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01fec01d",
  null
  
)

export default component.exports